import { render } from "./QuestionOneScreen.vue?vue&type=template&id=91d81c48&scoped=true&lang=html"
import script from "./QuestionOneScreen.vue?vue&type=script&lang=js"
export * from "./QuestionOneScreen.vue?vue&type=script&lang=js"

import "./QuestionOneScreen.vue?vue&type=style&index=0&id=91d81c48&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_omroepwest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d81c48"]])

export default __exports__